import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationSource, User } from 'src/app/interfaces/user';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LogService } from 'src/app/services/common/log.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-update-details-modal',
  templateUrl: './update-details-modal.component.html',
  styleUrls: ['./update-details-modal.component.scss']
})

export class UpdateDetailsModalComponent implements OnInit{
  @Input('user') public user: User;
  
  public pricingPlans = environment.stripePlans;
  public plan1Name: string;
  public plan2Name: string;
  public isAtUser: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private _checkoutService: CheckoutService,
    private _logService: LogService,
    private configService: ConfigService
  ) {
    this.plan1Name = this.configService.getTextFromKey('1-plan-name');
    this.plan2Name = this.configService.getTextFromKey('2-plan-name');
  }
  ngOnInit(): void {
    this.isAtUser = this.user.registrationSource === RegistrationSource.PmsImportAT || this.user.registrationSource === RegistrationSource.VetXmlFromAT;
  }

  public buySubscription(planId: string) {
    this._checkoutService.checkout([planId]).subscribe({
      next: () => {},
      error: (err) => {
        this._logService.error('An error occurred: ', err);
      },
    });
  }
}
